import React from 'react';
import ReactDOM from 'react-dom';
import Loader from './loader';

let type = 'normal';
let content = '';
let time = 5000;
const div = document.createElement('div');
document.body.appendChild(div);

function calls() {
  this.toaster(type, content, time);
}
function create() {
  return (msg) => {
    type = msg.type ? msg.type : 'normal';
    content = msg.content ? msg.content : '';
    time = msg.time ? msg.time : 5000;
    ReactDOM.render(<Loader />, div, calls);
  };
}

export default {
  show: create()
};



// WEBPACK FOOTER //
// ./src/Components/Loader/index.js